interface IStage {
    id: number;
    name: string;
    description?: string;
    start_at: string;
    end_at: string;
}

interface IPackage {
    id: number | null;
    code: string;
    name: string;
    image?: string;
    created_at: string;
    updated_at: string;
}

interface IPermission {
    id: number;
    permission: string;
    code: string;
}

export interface ISignon {
    id: number;
    username: string;
    first_name: string;
    last_name: string;
    user_type_id: number;
    email: string;
    phone?: string;
    has_two_factor: boolean;
    two_factor_since: string;
    token_two_factor: string;
    package: IPackage,
    position: string;
    project_id?: number;
    segment_id?: number;
    road_section_id?: number;
    package_id: number;
    custom_permissions: boolean;
    superadmin: false,
    stages: IStage[],
    permissions: IPermission[]
}

export const initialPackage: IPackage = {
    id: null,
    code: '',
    name: '',
    image: '',
    created_at: '',
    updated_at: ''
}

export const initialSignon: ISignon = {
    id: 0,
    username: "",
    first_name: "",
    last_name: "",
    user_type_id: 0,
    email: "",
    phone: "",
    has_two_factor: false,
    two_factor_since: "",
    token_two_factor: "",
    package: initialPackage,
    position: "",
    project_id: 0,
    segment_id: 0,
    road_section_id: 0,
    package_id: 0,
    custom_permissions: false,
    superadmin: false,
    stages: [],
    permissions: []
}     